"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGroups = fetchGroups;
exports.createGroup = createGroup;
exports.updateGroup = updateGroup;
exports.saveGroupThumbnail = saveGroupThumbnail;
var fetch_1 = require("./fetch");
var base_1 = require("./base");
var util_1 = require("../util");
function fetchGroups() {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = new URL("".concat(base_1.origin, "/api/groups"));
                    return [4 /*yield*/, (0, fetch_1.get)(url.href)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, (0, base_1.extractJsonOrThrow)(response, "fetch groups error")];
                case 2:
                    result = (_a.sent());
                    return [2 /*return*/, (0, util_1.withGroupPartTime)(result.groups)];
            }
        });
    });
}
function groupData(group) {
    var newGroup = __assign({}, group);
    delete newGroup.thumbnailImageUrl;
    delete newGroup.thumbnailImageFile;
    delete group.groupCreatedAtPartTime;
    for (var _i = 0, _a = Object.keys(newGroup); _i < _a.length; _i++) {
        var key = _a[_i];
        if (newGroup[key] == null || newGroup[key] === "")
            delete newGroup[key];
    }
    return new URLSearchParams(newGroup);
}
function createGroup(group) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = new URL("".concat(base_1.origin, "/api/groups"));
                    return [4 /*yield*/, (0, fetch_1.post)(url.href, { body: groupData(group) })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, (0, base_1.extractJsonOrThrow)(response, "create group error")];
                case 2:
                    id = (_a.sent()).id;
                    return [2 /*return*/, id];
            }
        });
    });
}
function updateGroup(group) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = new URL("".concat(base_1.origin, "/api/groups/").concat(group.id));
                    return [4 /*yield*/, (0, fetch_1.patch)(url.href, { body: groupData(group) })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, (0, base_1.extractJsonOrThrow)(response, "update group error")];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function saveGroupThumbnail(groupId, thumbnailImageFile) {
    return __awaiter(this, void 0, void 0, function () {
        var url, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = new URL("".concat(base_1.origin, "/api/groups/").concat(groupId, "/thumbnail"));
                    body = new FormData();
                    body.append("file", thumbnailImageFile);
                    return [4 /*yield*/, (0, fetch_1.post)(url.href, { body: body })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, (0, base_1.extractJsonOrThrow)(response, "save group thumbnail error")];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
